(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/start-page/assets/javascripts/unverified-email-dialog.js') >= 0) return;  svs.modules.push('/modules/start-page/assets/javascripts/unverified-email-dialog.js');
'use strict';

const initUnverifiedEmailDialog = () => {
  const trigger = document.querySelector('.js-email-verification-trigger');
  if (!trigger) {
    return;
  }
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.SPORT,
    icon: 'information',
    title: 'Hej och välkommen - bara ett steg kvar!',
    type: svs.ui.dialog.type.ERROR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Vi har skickat ett mejl till dig, öppna det och bekräfta din e-post. Sen är du redo att spela! ',
      align: svs.ui.dialog.message.align.CENTER
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
if (svs.isServer) {
  module.exports = initUnverifiedEmailDialog;
} else {
  setGlobal('svs.startpage.unverifiedEmailDialog', initUnverifiedEmailDialog);
}

 })(window);